import { render, staticRenderFns } from "./LocationDevices.vue?vue&type=template&id=22db0a19&scoped=true"
import script from "./LocationDevices.vue?vue&type=script&lang=js"
export * from "./LocationDevices.vue?vue&type=script&lang=js"
import style0 from "./LocationDevices.vue?vue&type=style&index=0&id=22db0a19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db0a19",
  null
  
)

export default component.exports